import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BonusqrService } from 'src/app/shared/servicio/bonusqr/bonusqr.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-qr-dinamico-generator',
  templateUrl: './qr-dinamico-generator.component.html',
  styleUrls: ['./qr-dinamico-generator.component.css'],
})
export class QrDinamicoGeneratorComponent implements OnInit, OnDestroy {
  loading = false;
  token = '';
  qrUrl = '';
  secondsRemaining = 0;
  expired = true;

  private _countdown: any;

  constructor(private _bonusqr: BonusqrService, public _helper: HelpersService) {}

  ngOnInit(): void {
    this.generate();
  }

  ngOnDestroy(): void {
    this._stopCountdown();
  }

  generate(): void {
    this.loading = true;
    this._stopCountdown();

    this._bonusqr.generateDynamicQr().subscribe(
      (data: any) => {
        this.loading = false;
        this.token = data.token;
        this.qrUrl = `${environment.ApiLink}/bono/d/${data.token}`;
        this.secondsRemaining = data.seconds_remaining;
        this.expired = false;
        this._startCountdown();
      },
      (error) => {
        this.loading = false;
        this._helper.modalError((error.error && error.error.message) || 'No se pudo generar el QR');
      }
    );
  }

  private _startCountdown(): void {
    this._countdown = setInterval(() => {
      this.secondsRemaining--;
      if (this.secondsRemaining <= 0) {
        this.secondsRemaining = 0;
        this.expired = true;
        this._stopCountdown();
      }
    }, 1000);
  }

  private _stopCountdown(): void {
    if (this._countdown) {
      clearInterval(this._countdown);
      this._countdown = null;
    }
  }
}
